export const PREFIX = 'APP';



// WEBPACK FOOTER //
// ./src/actions/constants.ts